<template>
  <div>
    <!-- O catálogo global é da rede inteira: só Full (chamado 2026-0023) -->
    <template v-if="isFull">
      <div class="action-buttons">
        <Button
          :label="t('Nova Forma de Pagamento')"
          icon="pi pi-plus"
          no-explanation="o rótulo diz o que acontece: abre o cadastro de uma forma nova"
          data-testid="formas-pagamento-btn-novo"
          @click="openModal" />
      </div>

      <!-- FormasPagamento Table -->
      <formas-pagamento-table
        ref="formasPagamentoTableRef"
        @edit="handleEdit">
      </formas-pagamento-table>
    </template>

    <!-- FormasPagamentoModal is centralized in ModalManager.vue - opened via eventBus -->

    <formas-pagamento-franquia-table class="fpf-secao"></formas-pagamento-franquia-table>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import FormasPagamentoTable from './FormasPagamentoTable.vue';
import FormasPagamentoFranquiaTable from './FormasPagamentoFranquiaTable.vue';
// FormasPagamentoModal is centralized in ModalManager.vue
import { eventBus } from '../../eventBus';
import { permissionsService } from '../../services/permissionsService';
import { log } from '../../utils/DebugLogger';

type FormaPagamentoId = number | string;

interface FormasPagamentoTableInstance {
  loadData: () => Promise<void> | void;
}

withDefaults(defineProps<{
  usuarioVersao?: number;
  translations?: Record<string, unknown>;
  datatablesLanguageUrl?: string;
}>(), {
  usuarioVersao: 0,
  translations: () => ({}),
  datatablesLanguageUrl: ''
});

// Get i18n composable
const { t } = useI18n();

// Reactive data
const formasPagamentoTableRef = ref<FormasPagamentoTableInstance | null>(null);
const isFull = computed<boolean>(() => permissionsService.getUserGroups().includes('Full'));

// Methods
const loadData = async (): Promise<void> => {
  log('FormasPagamentoPage', 'loadData', 'Refreshing table');
  if (formasPagamentoTableRef.value) {
    await formasPagamentoTableRef.value.loadData();
  }
};

const openModal = (): void => {
  log('FormasPagamentoPage', 'openModal', 'Opening new payment method modal via eventBus');
  eventBus.emit('modal.formas-pagamento.open', { action: 'new' });
};

const handleEdit = (formaPagamentoId?: FormaPagamentoId): void => {
  log('FormasPagamentoPage', 'handleEdit', 'Editing payment method ID via eventBus', formaPagamentoId);
  eventBus.emit('modal.formas-pagamento.open', { id: formaPagamentoId });
};

// Lifecycle
onMounted(() => {
  log('FormasPagamentoPage', 'mounted', 'Component mounted');

  // Set up eventBus listeners
  eventBus.on('formas-pagamento.edit', handleEdit);
  eventBus.on('formas-pagamento.new', openModal);
});

onBeforeUnmount(() => {
  log('FormasPagamentoPage', 'beforeUnmount', 'Cleaning up event listeners');

  // Clean up eventBus listeners
  eventBus.off('formas-pagamento.edit', handleEdit);
  eventBus.off('formas-pagamento.new', openModal);
});

// Expose methods for parent components
defineExpose({
  loadData,
  openModal,
  handleEdit
});
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.fpf-secao {
  margin-top: 32px;
}
</style>
